"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCampaignMultibrandProductsSkus = void 0;
const react_1 = require("react");
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const utils_1 = require("../utils");
const campaignProductsInitialValue = {
    vdf: {
        showcases: [],
        selectedProducts: [],
    },
    eud_mono: {
        showcases: [],
        selectedProducts: [],
    },
    bot_mono: {
        showcases: [],
        selectedProducts: [],
    },
};
class UseCampaignMultibrandProductsSkusError extends Error {
    constructor(message) {
        super(message);
        this.name = 'UseCampaignMultibrandProductsSkusError';
    }
}
const useCampaignMultibrandProductsSkus = () => {
    const [featureFlagValue, loading] = (0, useFeatureFlag_1.useFeatureFlag)('campaignProducts', null);
    return (0, react_1.useMemo)(() => {
        var _a, _b;
        if (loading || !featureFlagValue) {
            return campaignProductsInitialValue;
        }
        try {
            const parsedConfig = utils_1.campaignMultibrandShowcasesConfigSchema.validateSync(JSON.parse(String(featureFlagValue)));
            return parsedConfig;
        }
        catch (error) {
            (_b = (_a = window.NREUM) === null || _a === void 0 ? void 0 : _a.noticeError) === null || _b === void 0 ? void 0 : _b.call(_a, new UseCampaignMultibrandProductsSkusError(`Erro ao analisar a configuração de campaignProducts: ${error}`), {
                customAttributes: {
                    featureFlagValue: String(featureFlagValue),
                    error: error instanceof Error ? error.message : String(error),
                },
                customError: true,
            });
            return campaignProductsInitialValue;
        }
    }, [featureFlagValue, loading]);
};
exports.useCampaignMultibrandProductsSkus = useCampaignMultibrandProductsSkus;
